<template>
  <div style="min-height: 200px">
    <div class="table-responsive">
      <table id="trial" class="table table-bordered">
        <thead>
        <tr>
          <th class="text-center">SL No.</th>
          <th>Customer Name</th>
          <th>Contact No</th>
          <th class="text-center">Total Qty</th>
          <th class="text-center">Total Amount</th>
          <th class="text-center">Discount Amount</th>
          <th class="text-center">Net Amount</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in tableItems" :key="i">
            <td width="10%" class="text-center">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
            <td>{{ item.contact_name }}</td>
            <td>{{ item.phone }}  {{ item.mobile_no }}</td>
            <td class="text-right">{{ item.total_quantity }}</td>
            <td width="15%" class="text-right">{{ item.total_amount ? commaFormat(item.total_amount) : '' }}</td>
            <td class="text-right">{{ item.discount_amount ? commaFormat(item.discount_amount) : '' }}</td>
            <td class="text-right">{{ commaFormat(item.total_amount - item.discount_amount) }}</td>
          </tr>
          <tr v-if="currentPage === lastPage">
            <td colspan="3" class="text-right">Total</td>
            <td width="15%" class="text-right"> {{ totalValue && totalValue.total_total_quantity }}</td>
            <td class="text-right"> {{ totalValue && totalValue.total_total_amount }}</td>
            <td class="text-right"> {{ totalValue && totalValue.total_discount_amount }}</td>
            <td class="text-right"> {{ totalValue && totalValue.total_net_amount }}</td>
          </tr>
        </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import figureFormatter from "@/services/utils/figureFormatter";

const {commaFormat} = figureFormatter();
const props = defineProps({
  tableItems: {
    type: Array,
  },
  currentPage: Number,
  lastPage: Number,
  perPage: Number,
  totalValue: Object,
})
</script>
